var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("label-layouts"))),
                      ]),
                      _vm.hasModule
                        ? [
                            _c(
                              "w-list",
                              [
                                _vm._l(_vm.layouts, function (layout) {
                                  return _c(
                                    "w-list-item",
                                    { key: layout.ID },
                                    [
                                      _c("w-list-item-text", [
                                        _vm._v(_vm._s(layout.Name)),
                                      ]),
                                      _vm.isElectron
                                        ? _c(
                                            "w-list-item-action",
                                            [
                                              _c(
                                                "w-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: _vm.$ct(
                                                        "set-default-printer"
                                                      ),
                                                      expression:
                                                        "$ct('set-default-printer')",
                                                    },
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.editDefaultPrinter(
                                                        layout
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("w-fa", {
                                                    attrs: { icon: "print" },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "w-list-item-action",
                                        [
                                          _c(
                                            "w-button",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: _vm.$ct("copy-layout"),
                                                  expression:
                                                    "$ct('copy-layout')",
                                                },
                                              ],
                                              attrs: { disabled: _vm.coppying },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.copyLayout(layout)
                                                },
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "copy" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-list-item-action",
                                        [
                                          _c(
                                            "w-button",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: _vm.$ct("edit-layout"),
                                                  expression:
                                                    "$ct('edit-layout')",
                                                },
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editLayout(layout)
                                                },
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "pen" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-list-item-action",
                                        [
                                          _c(
                                            "w-button",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value:
                                                    _vm.$ct("delete-layout"),
                                                  expression:
                                                    "$ct('delete-layout')",
                                                },
                                              ],
                                              staticClass: "danger",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteLayout(
                                                    layout
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "trash" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                _c(
                                  "w-list-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.openNewLayoutModal()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "w-list-item-icon",
                                      [_c("w-fa", { attrs: { icon: "plus" } })],
                                      1
                                    ),
                                    _c("w-list-item-text", [
                                      _vm._v(
                                        _vm._s(_vm.$ct("create-new-layout"))
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ]
                        : _c(
                            "w-card-content",
                            [
                              _c("app-missing-module", {
                                attrs: { "module-id": _vm.labelModule },
                              }),
                            ],
                            1
                          ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.newLayoutModalOpen,
            callback: function ($$v) {
              _vm.newLayoutModalOpen = $$v
            },
            expression: "newLayoutModalOpen",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("create-new-layout")) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.newLayoutModalOpen = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-scroll-view",
                { attrs: { tag: "w-list" } },
                _vm._l(_vm.browses, function (browse) {
                  return _c(
                    "w-list-item",
                    {
                      key: browse.ID,
                      attrs: { to: `/settings/label-layout/new/${browse.ID}` },
                    },
                    [
                      _c("w-list-item-icon", [
                        _c("div", {
                          class: _vm.getIconClassByBrowseId(browse.ID),
                        }),
                      ]),
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(browse.Name.getTranslation(_vm.locale))),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isElectron && _vm.printerSettingsModalLayoutId != 0
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-label-layout-edit-electron-properties", {
                attrs: {
                  "layout-id": _vm.printerSettingsModalLayoutId,
                  printers: _vm.printers,
                },
                on: {
                  close: function ($event) {
                    _vm.printerSettingsModalLayoutId = 0
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }